const selectSelectedProfilesProperties = (state) => state.share.selectedProfilesProperties
const selectMessage = (state) => state.share.message
const selectLoader = (state) => state.share.loader
const selectError = (state) => state.share.error
const selectProfilesProperties = (state) => state.share.profilesProperties

export {
  selectSelectedProfilesProperties,
  selectMessage,
  selectLoader,
  selectError,
  selectProfilesProperties,
}
